export default __webpack_public_path__ + "static/media/Snd_TryK.c6261e68.mp3";